export enum PromptSamplingModeEnum {
  MostPredictable = 'most-predictable',
  Predictable = 'predictable',
  SlightlyPredictable = 'slightly-predictable',
  Balanced = 'balanced',
  SlightlyCreative = 'slightly-creative',
  Creative = 'creative',
  MostCreative = 'most-creative',
}
